import {Component, Input} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {SpinnerService} from '~shared/components/buttons/spinner/spinner.service';
import {ProcessConfigurationService} from '~core/services';
import {Lottery, ProcessConfiguration} from '~core/models';
import {TooltipTranslationService} from '~shared/translations';
import {EventAdministrationService} from "~features/tixx-select/event-administration.service";

/**
 * Displays webpage individualization information
 */
@UntilDestroy()
@Component({
  selector: 'app-optional-checkbox-info',
  templateUrl: './optional-checkbox-info.component.html',
})
export class OptionalCheckboxInfoComponent {
  @Input() public selectedLottery: Lottery;
  public processConfiguration: ProcessConfiguration;
  public spinnerName: string = 'specialRequirementsLoading';
  public spinnerLoading: boolean = true;

  constructor(
    public tooltipTranslations: TooltipTranslationService,
    public tixxSelectOverviewService: EventAdministrationService,
    private processConfigurationService: ProcessConfigurationService,
    private spinnerService: SpinnerService,
  ) {
    this.processConfigurationService.castCurrentProcessConfiguration.pipe(untilDestroyed(this))
      .subscribe((data: ProcessConfiguration) => {
        if (data) {
          this.processConfiguration = data;
          this.spinnerService.hide(this.spinnerName);
        }
      });
  }

  /**
   * Opens the edit webpage individualization sidebar
   */
  public editSpecialRequirement(): void {
    this.tixxSelectOverviewService.toggleAllModal(false);
    this.tixxSelectOverviewService.toggleEditSpecialRequirementModal(true);
  }

}
